<template>
  <div class="row justify-content-center py-md py-sm-xxl">
    <div class="buttons d-flex flex-column align-items-stretch row-gap-md text-center">
      <h2>Log in</h2>
      <apple-button
        variant="login"
        @error="appleSignupError"
        @success="facebookOrGoogleLogin"/>
      <facebook-button
        variant="login"
        @facebookSignupError="facebookSignupError"
        @facebookConnected="facebookOrGoogleLogin"/>

      <div ref="googleButtonWrapper">
        <google-button
          variant="login"
          :width="wrapperWidth"
          @error="googleSignupError"
          @success="facebookOrGoogleLogin"/>
      </div>

      <h5 class="mb-0">
        Or
      </h5>

      <base-form-errors :errors="formErrors"/>

      <form
        class="d-flex flex-column align-items-stretch row-gap-md"
        @submit.prevent="submit">
        <base-input
          v-model.trim="email"
          :validations="v$.email"
          name="email"
          autocomplete="email"
          type="email"
          input-id="email"
          label="Email Address"/>
        <base-input
          v-model="password"
          :validations="v$.password"
          name="password"
          autocomplete="current-password"
          type="password"
          input-id="password"
          label="Password"/>
        <button
          :disabled="formDisabled"
          class="btn btn-primary w-100">
          Log In
        </button>
      </form>

      <router-link
        class="btn w-100 btn-outline-primary"
        :to="{ name: 'style-quiz-intro' }">
        Create an Account
      </router-link>

      <a
        class="text-armor text-decoration-none small-text"
        href="/password_reset/">
        Forgot Password?
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import FacebookButton from './FacebookButton'
import GoogleButton from './GoogleButton'
import AppleButton from './AppleButton'
import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import BaseFormErrors from '@/components/global/BaseFormErrors.vue'
import BaseInput from '@/components/global/BaseInput.vue'

export default {
  components: {
    AppleButton,
    FacebookButton,
    GoogleButton,
    BaseFormErrors,
    BaseInput
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data () {
    return {
      email: '',
      password: '',
      formDisabled: false,
      formErrors: [],
      wrapperWidth: 0
    }
  },
  mounted () {
    this.updateWrapperWidth()
    window.addEventListener('resize', this.updateWrapperWidth)
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.updateWrapperWidth)
  },
  methods: {
    ...mapActions('client', [
      'login'
    ]),
    facebookOrGoogleLogin (formData) {
      this.completeSubmit(formData)
    },
    submit () {
      this.v$.$touch()
      if (this.v$.$invalid) return

      const formData = {
        email: this.email,
        password: this.password
      }
      this.completeSubmit(formData)
    },
    facebookSignupError (errors) {
      this.formErrors = [errors.message]
    },
    googleSignupError (error) {
      this.formErrors = [error]
    },
    appleSignupError (error) {
      if (error.error !== 'popup_closed_by_user') {
        this.formErrors = [error.error]
      }
    },
    async completeSubmit (formData) {
      this.formDisabled = true

      try {
        await this.login(formData)
        this.formErrors = []
      } catch (errors) {
        this.formErrors = errors
      }

      this.formDisabled = false
    },
    updateWrapperWidth () {
      this.wrapperWidth = this.$refs.googleButtonWrapper.clientWidth || 0
    }
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons {
  width: 315px;

  @include media-tablet-or-larger() {
    width: 400px;
  }
}
</style>
